/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { Grid, Button } from '@material-ui/core'
import '../Elegibilidad/Style/crearFormularioElegibilidad.scss'
import { useFormElegibilidad } from '../../../context/ElegibilidadContext'
import { useAuthentication } from '../../../context/authenticationContext'
import { useFormik } from 'formik'
import { useHistory } from 'react-router-dom'
import swal from 'sweetalert'
import Table41 from './Tables/TablesSec4/Table41'
import SaveIcon from '@material-ui/icons/Save'
import ExitIcon from '@material-ui/icons/ExitToApp'
import ReactTooltip from 'react-tooltip'
import { useEligibility } from '../../../context/EligibilityContext'
import * as Yup from 'yup'

const ElegibilidadSec4 = (props) => {
  const { goToStep } = props

  const history = useHistory()
  const { userCountry } = useAuthentication()
  const [state, dispatch] = useEligibility()
  const { setEligibilityForm, EligibilityForm } = useFormElegibilidad()
  const [loading, setLoading] = useState(false)

  useState(false)

  // NEXT
  const [loadingExchange, setLoadingExchange] = useState(false)
  const [exchangeError, setExchangeError] = useState(false)
  const [enablePYME, setEnablePYME] = useState(true)

  const EvaluationDataSchema = Yup.object().shape({
    validTable41: Yup.boolean().oneOf([true], 'Faltan campos en la tabla'),
  })

  const formik = useFormik({
    // enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      validTable41: false,
    },
    validationSchema: EvaluationDataSchema,
    onSubmit: () => {
      next()
    },
  })

  const fakeSave = async (values, borrador) => {
    swal({
      title: 'Formulario Guardado',
      icon: 'success',
      button: 'Entendido',
    })
  }

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const next = () => {
    dispatch({ type: 'SET_STATE', payload: 5 })
    goToStep(5)
  }

  const previous = () => {
    dispatch({ type: 'SET_STATE', payload: 3 })
    goToStep(3)
  }

  useEffect(() => {
    setLoadingExchange(false)
    setExchangeError(true)
    setEnablePYME(false)
  })

  return (
    <>
      {/* Comienzo borrador */}
      <Grid
        container
        md={12}
        sm={12}
        spacing={1}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Grid item>
          <div
            data-tip
            data-for="exitPop"
            style={{
              backgroundColor: 'red',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <ExitIcon style={{ transform: 'scaleX(-1)' }} />
            <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
              <span>Regresar</span>
            </ReactTooltip>
          </div>
        </Grid>
        <Grid item>
          <div
            data-tip
            onClick={() => fakeSave()}
            data-for="savePop"
            style={{
              backgroundColor: '#5cb85c',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <SaveIcon />
          </div>
          <ReactTooltip id="savePop" effect="solid" backgroundColor="#5cb85c">
            <span>Guardar Borrador</span>
          </ReactTooltip>
        </Grid>
      </Grid>
      <br></br>
      {/* Fin borrador */}
      <form id="evaluation-data-form" onSubmit={formik.handleSubmit}>
        <Grid item xs={12} sm={12} md={12}>
          <h1 className="h1text">GÉNERO</h1>
          <br />
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={12}>
            <label className="responsiveLabel">
              1.- Seleccione el tipo de actividades dentro de la MIPYME que son
              realizadas por mujeres y hombres (Obligatorio)
            </label>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Table41 formik={formik}></Table41>
            {formik.errors.validTable41 ? (
              <div
                style={{
                  color: 'red',
                  marginTop: '3px',
                  fontSize: '13px',
                }}
              >
                {formik.errors.validTable41}
              </div>
            ) : null}
          </Grid>

          <Grid container spacing={1} className="button__container">
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'left' }}
              className="continerButtonNav"
            >
              <Button
                onClick={() => previous()}
                variant="contained"
                className="button__wizard button__previous"
                disabled={loading}
              >
                Anterior
              </Button>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              style={{ textAlign: 'right' }}
              className="continerButtonNav"
            >
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  style={{ textAlign: 'right' }}
                >
                  {enablePYME ? (
                    <Button
                      onClick={() => validateFormStatus()}
                      className="button__wizard button__next"
                      disabled={loadingExchange || exchangeError}
                    >
                      Siguiente
                    </Button>
                  ) : (
                    <Button
                      onClick={() => validateFormStatus()}
                      className="button__wizard button__next"
                      disabled={false}
                    >
                      Siguiente
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default ElegibilidadSec4
